/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Resource } from '@ngxp/rest';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ResourceRepository } from '../resource/resource.repository';
import { ListResource } from '../resource/resource.util';
import { CreateListItemProps, ListResourceLoadActions, ResourceUriProps } from './actions';

export class ListResourceEffects<T extends ListResource> {
  constructor(
    private readonly actions$: Actions,
    private readonly repository: ResourceRepository,
    private readonly resourceActions: ListResourceLoadActions,
  ) {}

  loadByUri$ = createEffect(() =>
    this.actions$.pipe(
      ofType(this.resourceActions.loadAction),
      switchMap((props: ResourceUriProps & Action) => {
        return this.repository.getResource<T>(props.resourceUri).pipe(
          map((listResource: T) => this.resourceActions.loadListSuccessAction({ listResource })),
          catchError((error) => of(this.resourceActions.loadFailureAction({ error }))),
        );
      }),
    ),
  );

  createListItem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(this.resourceActions.createListItemAction),
      switchMap((props: CreateListItemProps & Action) => {
        return this.repository.createResource(props.payload).pipe(
          map((resource: Resource) => this.resourceActions.createListItemSuccessAction({ resource })),
          catchError((error) => of(this.resourceActions.createListItemFailureAction({ error }))),
        );
      }),
    ),
  );
}
